import { HttpClient } from '@angular/common/http';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    signal
} from '@angular/core';
import { BusinessAreaEnum } from 'app/core/enums/generated/BusinessAreaEnum';
import { PermissionRole } from 'app/core/enums/generated/PermissionRole';
import { SecurityService } from 'app/core/security/security.service';
import { NotificationService } from 'app/notification.service';
import { FdaRecallVm } from 'app/shared/generated/NdcDirectory/Models/FdaRecallVm';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ResizableWidgetComponent } from '../resizable-widget/resizable-widget.component';

@Component({
    selector: 'pcg-resizable-recalls-widget',
    imports: [
        TableModule, 
        TooltipModule, 
        SkeletonModule,

        ResizableWidgetComponent
    ],
    templateUrl: './resizable-recalls-widget.component.html',
    styleUrl: './resizable-recalls-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResizableRecallsWidget {

    private readonly http = inject(HttpClient);
    private readonly toastr = inject(NotificationService);
    private readonly sec = inject(SecurityService);
    private readonly cdr = inject(ChangeDetectorRef);

    readonly recalls = signal<FdaRecallVm[]>([]);
    readonly loading = signal(false);
    readonly hasRecalls = signal(false);

    private hasNdcModule = false;

    ngOnInit() { this.initialize(); }

    private initialize(): void {
        this.hasNdcModule = this.sec.hasModuleAccess(
            [BusinessAreaEnum.NDC],
            SecurityService.setMinRole(PermissionRole.User),
        );
        if (this.hasNdcModule) {
            this.loadRecalls();
        }
    }

    loadRecalls(): void {        
        if (!this.hasNdcModule) {
            return;
        }

        this.loading.set(true);
        const url = 'api/NdcDirectory/NdcDirectory/GetFdaRecallListWidget/?state=FL&status=Ongoing&isInFormulary=true';

        this.http.get<FdaRecallVm[]>(url).subscribe({
            next: (lst) => {
                this.recalls.set(lst);
                this.hasRecalls.set(lst.length > 0);
                this.loading.set(false);
                this.cdr.markForCheck();
            },
            error: (error) => {
                this.toastr.showError('Error fetching recalls');
                console.error('Error fetching recalls:', error);
                this.loading.set(false);
                this.cdr.markForCheck();
            },
        });
    }
}
